import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ControlledList, DataGridLayoutGrid } from 'framework/list';
import { useShowContext } from 'framework/show';
import { ComplianceProjectStatus } from '../types';
import ComplianceControlActiveFailuresField from '../shared/fields/ComplianceControlActiveFailuresField';
import ComplianceControlLastCheckField from '../shared/fields/ComplianceControlLastCheckField';
import ComplianceControlModeField from '../shared/fields/ComplianceControlModeField';
import ComplianceControlNameField from '../shared/fields/ComplianceControlNameField';
import ComplianceControlStatusField from '../shared/fields/ComplianceControlStatusField';

const ProjectControlsSection = () => {
  const { data } = useShowContext<ComplianceProjectStatus>();
  const { controls } = data.getData();

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Typography variant="h6" color="primary" sx={{ py: 2 }}>
        Controls
      </Typography>
      <ControlledList
        data={{
          items: controls,
          totalElements: controls.length,
          totalPages: controls.length ? 1 : 0,
        }}
      >
        <DataGridLayoutGrid
          rowKeySource="controlId"
          minWidth="1100px"
          showPagination={false}
          showTotal={false}
          rowProps={{
            sxRowContainer: {
              border: 0,
              my: 0,
              borderBottom: '1px solid var(--mui-palette-TableCell-border)',
            },
            sx: {
              alignItems: 'center',
            },
          }}
        >
          <ComplianceControlNameField source="name" controlIdSource="controlId" label="Control" size={2.5} />
          <ComplianceControlModeField source="effectiveMode" enforceAtSource="enforceAt" label="Mode" size={1.5} />
          <ComplianceControlStatusField
            source="effectiveMode"
            freshnessSource="freshness"
            activeFailuresSource="activeFailures"
            failingComponentsSource="failingComponents"
            label="Status"
            size={1.5}
          />
          <ComplianceControlLastCheckField
            source="lastStatus"
            latestSource="latest"
            lastCheckedAtSource="lastCheckedAt"
            label="Last check"
            size={2.5}
          />
          <ComplianceControlActiveFailuresField
            source="failingComponents"
            activeFailuresSource="activeFailures"
            label="Active failures"
            size={4}
          />
        </DataGridLayoutGrid>
      </ControlledList>
    </Box>
  );
};

export default ProjectControlsSection;
